import React, {useContext, useState} from 'react';
import FormContext from "formContext";
import {injectIntl} from "react-intl";
// import Logger from '@ffw/logger-lib';

function Checkbox({intl, settings, onClickLinkCb, ...rest}) {
    const {label, title, state, labelLink, labelLinkText, secondaryLabelLink, secondaryLabelLinkText, linksConjuction, labelLinkOpenInNewTab, errors, hidden = false, required = true, yesValue = false, emptyValue, skipOnEmpty = false, divClasses = '', legalPageId} = settings || {};
    const name = rest.name || (settings && settings.name);
    const {additionalData} = useContext(FormContext);
    let dynamicLink = {};
    if (process.env.REACT_APP_LEGAL_PAGES === "true") {
        // Terms and conditions case
        if (legalPageId == 'rbd_legal_pages.terms_and_conditions') {
            dynamicLink = additionalData.termsAndConditions;
        }
        // Privacy policy case
        if (legalPageId == 'rbd_legal_pages.privacy_policy') {
            dynamicLink = additionalData.privacyPolicy;
        }
    }
    if (skipOnEmpty) {
        rest["data-skip-empty-field"] = true;
    }
    if (emptyValue) {
        rest["data-empty-field-value"] = emptyValue;
    }

    const hasErrors = (errors && ((errors.hasOwnProperty(name) && errors[name].length) || (required && errors.hasOwnProperty('generalError'))));
    const id = `field--input--${name}`;

    const renderTitle = () => {
        if (!title) {
            return null;
        }

        return (
            <div className="form-group__label">{intl.formatMessage({id: title})}</div>
        )
    };

    const renderLabel = () => {
        let link = '';
        let secondaryLink = '';
        if (legalPageId && dynamicLink !== undefined && dynamicLink.url !== undefined && dynamicLink.title !== undefined) {
            const linkAttributes = {
                href: dynamicLink.url.S,
                target: (labelLinkOpenInNewTab) ? '_blank' : '_self',
            };

            if (onClickLinkCb) {
                linkAttributes["onClick"] = onClickLinkCb;
            }

            link = <a {...linkAttributes}>{dynamicLink.title.S}</a>
        }
        else {
            if (labelLink && labelLinkText) {
                const linkAttributes = {
                    href: intl.formatMessage({id: labelLink}),
                    target: (labelLinkOpenInNewTab) ? '_blank' : '_self',
                };

                if (onClickLinkCb) {
                    linkAttributes["onClick"] = onClickLinkCb;
                }

                link = <a {...linkAttributes}>{intl.formatMessage({id: labelLinkText})}</a>
            }
        }
        // TBD: the secondary link isn't working from CMS now, because there is no secondary links for CA OpCo,
        // so it's out of scope of the MVP
        if (secondaryLabelLink && secondaryLabelLinkText) {
            const linkAttributes = {
                href: intl.formatMessage({id: secondaryLabelLink}),
                target: (labelLinkOpenInNewTab) ? '_blank' : '_self',
            };

            if (onClickLinkCb) {
                linkAttributes["onClick"] = onClickLinkCb;
            }

            secondaryLink = <a {...linkAttributes}>{intl.formatMessage({id: secondaryLabelLinkText})}</a>
        }
        return (
            <span className="selection-control__label">
        <span dangerouslySetInnerHTML={{ __html: intl.formatMessage({id: label})}} /> {link && secondaryLink ? intl.formatMessage({id: linksConjuction}, {linkPrimary: link, linkSecondary: secondaryLink}) : link}

                {!required && <span className="form-group__optional"> {intl.formatMessage({id: 'FormElements.Label.Optional'})}</span>}
      </span>
        )
    };

    const renderErrors = () => {
        const renderable = [];
        if (hasErrors && errors.hasOwnProperty(name) && errors[name].length) {
            renderable.push(
                <div key={`errorField-${name}`} className="form-group__feedback">{errors[name]}</div>
            );
        }
        return renderable;
    };

    if (hidden) {
        return '';
    }

    let checked = '';
    if (state && state.hasOwnProperty(name)) {
        if (emptyValue !== state[name]) {
            checked = state[name];
        }
    }

    return (
        <div className={`form-group form-group--selection-control ${hasErrors ? 'form-group--error' : ''} ${divClasses}`}>
            {renderTitle()}
            <div className="form-group__input">
                <label htmlFor={id} className="selection-control selection-control--checkbox">
          <span className="selection-control__input">
            <input
                id={id}
                name={name}
                type="checkbox"
                value={(legalPageId && dynamicLink !== undefined && dynamicLink.version !== undefined) ? legalPageId : (yesValue ? 'yes' : true)}
                checked={(checked)}
                required={required}
                {...rest}
            />
            <span className="icon selection-control__control" aria-hidden="true">
              <svg viewBox="0 0 16 16">
                <polyline points="2.1,8.5 6.2,12.4 13.9,5.1"/>
              </svg>
            </span>
          </span>
                    {renderLabel()}
                </label>
            </div>
            {renderErrors()}
        </div>
    );

}

export default injectIntl(Checkbox);
